import * as React from 'react';
import { ExtraWorkDaysModel } from './model/ExtraWorkDaysModel';
import { GeneralSettingsController } from './controller/GeneralSettingsController';
import { Paper } from 'components/paper';
import { Button, Table, TableHead, TableBody, TableRow, TableCell, Icon } from '@material-ui/core';
import { AddExtraWorkDayDialog } from './AddExtraWorkDayDialog';

export class ExtraWorkDaysPaper extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {addDialogVisible: false};

        this.handleAddClicked = this.handleAddClicked.bind(this);
        this.handleDialogClosed = this.handleDialogClosed.bind(this);
    }

    private handleAddClicked() {
        this.setState({addDialogVisible: true});
    }

    private handleDialogClosed() {
        this.setState({addDialogVisible: false});
    }

    public render() {
        return (
            <Paper title="Extra work days and holidays" desc="You can set the extra work days and holidays here.">
                <Button color="default" variant="contained" onClick={this.handleAddClicked}>Add</Button>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.model.extraWorkDays.map((item, index) => {
                            return (
                                <TableRow key={"ewdrow-" + index}>
                                    <TableCell>{item.date}</TableCell>
                                    <TableCell>{item.desc}</TableCell>
                                    <TableCell>{item.isHoliday ? "Holiday" : "Extra work day"}</TableCell>
                                    <TableCell>
                                    <Icon style={{ color: '#c32', margin: '2px', cursor: 'pointer', fontSize: '16px' }} onClick={() => { this.props.controller.onDeleteExtraWorkDay(item.id) }}>delete</Icon>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>

                {this.state.addDialogVisible && (
                    <AddExtraWorkDayDialog controller={this.props.controller} onClose={this.handleDialogClosed} />
                )}
                
            </Paper>
        );
    }

}

export interface Props {

    model: ExtraWorkDaysModel;
    controller: GeneralSettingsController;

}

export interface State {

    addDialogVisible: boolean;

}